import * as React from 'react';
import { scrollToAnchor } from '@cian/newbuilding-utils';
import { useSelector } from 'react-redux';

import { trackOffersEscrouLabelClick } from './tracking';
import { EscrowBlock } from '../../components/EscrowBlock';
import { isEscrowHouseSelector } from '../../selectors/newbuilding';
import { getSelectedHouseId } from '../../selectors/offers';

export function EscrowBlockContainer() {
  const isEscrow = useSelector(isEscrowHouseSelector);
  const houseId = useSelector(getSelectedHouseId);
  const text = houseId ? 'Сделка с эскроу-счётом' : 'Есть корпуса со сделкой с эскроу–счётом';

  const onReliableLabelClick = (event: React.MouseEvent<HTMLElement>) => {
    scrollToAnchor({
      anchor: '#escrow',
      offset: 100,
      hasRelocation: false,
      hasAnimation: true,
    })(event);
    trackOffersEscrouLabelClick();
  };

  return isEscrow ? <EscrowBlock text={text} onClick={onReliableLabelClick} /> : null;
}
